import { TIcon } from "@/app/types/types";

const CloseIcon = ({ color }: TIcon) => {
    return (
        <svg width="14" height="15" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1.4 14.15L0.35 13.1L5.95 7.5L0.35 1.9L1.4 0.849998L7 6.45L12.6 0.849998L13.65 1.9L8.05 7.5L13.65 13.1L12.6 14.15L7 8.55L1.4 14.15Z" fill={color} />
        </svg>
    );
}

export default CloseIcon;